import React from "react";
import { createFileRoute } from "@tanstack/react-router";
//
import { zodValidator } from "@tanstack/zod-adapter";

import { queryClient } from "@config/tanstack/tanstackQuery";
import { springHealthEligibileQueryOpts } from "src/backendApi/queries/spring-health-queries";
//
import { SpringHealthRegisterPage } from "@pages/spring-health-register-page";
import { RouterLoadingComponent } from "@components/router-loading-component";

import { springHealthVerifySchema } from "./verify";

export const Route = createFileRoute("/spring-health/register")({
  component: SpringHealthRegisterPage,
  validateSearch: zodValidator(springHealthVerifySchema),
  pendingComponent: () => <RouterLoadingComponent bgColor="#00382D" />,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    return await queryClient.ensureQueryData(
      springHealthEligibileQueryOpts({ ...deps }),
    );
  },
});
